// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ebfdc29a","667":"acc916be"}[chunkId] + ".chunk.js";
};